module.exports = __webpack_public_path__ + "img/51626508_L.5fd2cc9a.png";